import Cookies from 'js-cookie'

export default {
    user () {
        return this.$store.state.user
    },

    check () {
    	if(Cookies.get('AUTHENTICATED')){
    		return true
    	} else {
    		return false
    	}
        //return localStorage.getItem('AUTHENTICATED') //get token from localStorage
    }
}